// 环境配置
const baseEnv = [
  {
    path: '/env/serverlist', // 基础环境
    component: () => import(/* webpackChunkName: "serverlist" */ '@/views/envSet/serverList'),
    meta: {
      title: '基础环境',
    },
  },
  {
    path: '/env/serverdetail/:id', // 查看/编辑
    component: () => import(/* webpackChunkName: "serverdetail" */ '@/views/envSet/serverDetail'),
    meta: {
      title: '查看/编辑',
    },
  },
  {
    path: '/env/serverconf/:id', // 配置文件
    component: () => import(/* webpackChunkName: "serverconf" */ '@/views/envSet/serverConf'),
    meta: {
      title: '配置文件',
    },
  },
];

export default baseEnv;
